import Table from './Table';
export default Table;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/index.js
// module id = 846
// module chunks = 3